import { orchestrator } from 'satcheljs';
import { onMonthCellDoubleClick } from '../actions/monthCellOnClickActions';
import { lazyShowFullComposeInEditMode } from 'owa-calendar-compose-form-store';
import { FULL_COMPOSE_VIEW_TYPE_MODAL } from 'owa-calendar-helpers-types/lib/ComposeTypes';
import EventScope from 'owa-service/lib/contract/EventScope';
import { getSurfaceStore } from 'owa-calendar-surface-surface-store';
import { updateSelectedDate } from 'owa-calendar-surface';
import getDefaultStart from 'owa-calendar-forms-common/lib/utils/getDefaultStart';
import { returnTopExecutingActionDatapoint } from 'owa-analytics';

/**
 * Opens the full-compose for creating a new event
 *
 */
orchestrator(onMonthCellDoubleClick, actionMessage => {
    const surfaceStore = getSurfaceStore();

    const datapoint = returnTopExecutingActionDatapoint();
    datapoint.addCustomData({ currentDateRangeType: surfaceStore.dateRangeType });

    updateSelectedDate(actionMessage.date, surfaceStore);

    lazyShowFullComposeInEditMode.importAndExecute(
        {
            Start: getDefaultStart(actionMessage.date),
            IsAllDayEvent: false,
        },
        EventScope.Default,
        false /* itemHasUpdates */,
        'Surface',
        FULL_COMPOSE_VIEW_TYPE_MODAL,
        null /* extractionSourceId */
    );
});
